import {domSelectors} from "~/globals";
import Page from "~/pages/Page";
import $ from "jquery";
import "~/jquery-validate.js";
import {getApi, login, clearBackendSession, handleError, type UserInfo} from "~/auth";
import {getParameterValue, isNullish, navigateTo} from "~/utils";
import * as bootstrap from "bootstrap";
import * as bootbox from "bootbox";
import UI from "~/ui";

class SignIn  {
    constructor(page: Page) {
        this._page = page;
    }

    private _page: Page;
    private _loginCallbacks: ((user: UserInfo) => Promise<void>)[] = [];

    public onLogin(value: (user: UserInfo) => Promise<void>) {
        this._loginCallbacks.push(value);
    }

    activate(): Promise<void> {
        const that = this;
        const $emailInput = $("#email-input-login");
        const $passwordInput = $("#password-input-login");
        const $emailInputMobile = $("#email-input-login-mobile");
        const $passwordInputMobile = $("#password-input-login-mobile");

        
        const handleEnterKeyup = (e: any, $otherField: JQuery, $submit: JQuery) => {
            if (e.key === "Enter" && $otherField.val() != "")
                $submit.trigger("click");
            else
                that.clearMessage();
        }
        const handleSubmit = async ($passwordInput: JQuery, $emailInput: JQuery, $passwordError: JQuery, $emailError: JQuery, $form: JQuery) => {
            const isPasswordValid = $passwordInput.val() != null && $passwordInput.val() != '';
            const isEmailValid = $emailInput.val() != null && $emailInput.val() != '';

            $passwordError.toggle(!isPasswordValid);
            $emailError.toggle(!isEmailValid);

            if (isPasswordValid && isEmailValid) {
                const username = $emailInput.val() as string;
                const password = $passwordInput.val() as string;
                UI.showWait();
                
                try {
                    let user = await login(username, password);

                    that._loginCallbacks.forEach(async callback => {
                        await callback(user);
                    })

                } catch (err) {
                    let errHtml = handleError(err);
                    that.showMessage(errHtml);
                } 
            }
        };

        $emailInput.on('keyup', (e) => {
            handleEnterKeyup(e, $("#password-input-login"), $("a#submitLogin"));
        });
        $passwordInput.on('keyup', (e) => {
            handleEnterKeyup(e, $("#email-input-login"), $("a#submitLogin"));
        });
        // $emailInputMobile.on('keyup', (e)=>  {
        //     handleEnterKeyup(e, $("#password-input-login-mobile"), $("a#submitLoginMobile"));
        // });
        // $passwordInputMobile.on('keyup', (e)=>  {
        //     handleEnterKeyup(e, $("#email-input-login-mobile"), $("a#submitLoginMobile"));
        // });

        $("a#submitLogin").on('click', e => {
            e.preventDefault();
            e.stopImmediatePropagation();
            const _ = handleSubmit( 
                $("#password-input-login"),
                $("#email-input-login"),
                $("#password-error"),
                $("#email-error"),
                $("#form-login")
            );
            return false;
        });

        // $("a#submitLoginMobile").on('click', e => {
        //     e.preventDefault();
        //     handleSubmit(
        //         $("#password-input-login-mobile"),
        //         $("#email-input-login-mobile"),
        //         $("#password-error-mobile"),
        //         $("#email-error-mobile"),
        //         $("#form-login-mobile")
        //     );
        // });


        

        return Promise.resolve();
    }


    public clearMessage(): void {
        $('div.messageText')
            .html("")
            .addClass("d-none")
            .removeClass("show");
    }

    public showMessage(message: string, type?: string) {
        let $msg = $('div.messageText');
        UI.hideWait();
        $msg.html(message)
            .removeClass("d-none")
            .removeClass("fade");

        if (type != undefined) {
            if(type.startsWith("alert-")){
                let classesToRemove = $msg.attr("class")?.split(" ").filter(c => c.startsWith("alert-")) ?? [];
                if (classesToRemove.length > 0) {
                    $msg.removeClass(classesToRemove.join(" "));
                }
            }
            $msg.addClass(type);
        }
    }



   

}

export default SignIn;